require('@/bootstrap');
window.axios.defaults.baseURL = '/api/' + (window.location.href.split('/')[3] === 'admin' ? 'admin' : 'moviary');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';

import { ZiggyVue } from 'ziggy';
import { Ziggy } from '@/ziggy';
// override generated url und port to support dynamic domains on browser requests
// fixme: remove this from here and write own command extending the ziggy:generate
Ziggy.url = window.location.origin;
Ziggy.port = window.location.port;

import moment from 'moment';
import VueEasyLightbox from 'vue-easy-lightbox';

createInertiaApp({
  resolve: (name) => {
    if (name.startsWith('default::')) {
      return require(`../../structures/default/${name.substr(9)}`).default;
    }
    if (name.startsWith('admin::')) {
      return require(`../admin/${name.substr(7)}`).default;
    }
    if (name.startsWith('structures::')) {
      return require(`../../structures/${name.substr(12)}`).default;
    }
    return require(`./${name}`).default;
  },
  progress: {
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 250,
    // The color of the progress bar.
    color: 'var(--color-primary)',
    // Whether to include the default NProgress styles.
    includeCSS: false,
    // Whether the NProgress spinner will be shown.
    showSpinner: true,
  },
  setup({ el, App, props, plugin }) {
    let app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ZiggyVue, Ziggy)
      .mixin({
        methods: {
          // trans zum Aufruf als globale Methode in Vue-Komponenten, z.B. {{ trans('auth.failed') }}
          trans(key, replacements) {
            window.Lang.setLocale(props.initialPage.props.locale);
            return window.Lang.get(key, replacements);
          },
          moment,
        },
      });
    app.config.globalProperties.aspect = window.location.href.split('/')[3] === 'admin' ? 'admin' : 'moviary';
    app.config.globalProperties.routePrefix = 'resources';
    if (window.location.href.split('/')[3] === 'admin') {
      app.config.globalProperties.routePrefix = 'admin.resources';
    }
    app.mount(el);
  },
});